import PropTypes from 'prop-types';
import { useMemo, useState } from 'react';
import ModalTwoFactor from '../../../components/TwoFactor/ModalTwoFactor';
import * as Styled from './Information.styles';

import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { useTheme } from 'styled-components';
import DropDown from '../../../components/DropDown/DropDown';
import {
  pixRefundAproveFetchAction,
  pixRefundNegadedFetchAction,
  pixTransactionAproveCelcoinFetchAction,
  pixTransactionAproveFetchAction,
  pixTransactionNegadedFetchAction,
  getReceiptForView
} from '../../../store/fetchActions/pixTransactionsActions';
import ModalPixRefundCreateDevoluction from '../../AdminPix/components/Modal/ModalPixRefundCreateDevoluction';
import { showAlert } from '../../../store/ducks/sweetAlert';
import { Grid } from '@mui/material';
import Button from '../../../components/Button/Button';
import ViewPdfIframe from '../../../components/ViewPDF';
export default function InformationPix({
  title,
  data,
  color,
  bold,
  idTransaction,
  showButton,
  onClose,
  refund,
  isAproved,
  allowRefund,
}) {
  const theme = useTheme();

  const dispatch = useDispatch();

  const [expanded, setExpanded] = useState('');
  const [disableButon, setDisableButon] = useState(false);
  const [showTwoFactorModal, setShowTwoFactorModal] = useState(false);
  const [isAprove, setIsAprove] = useState(false);
  const [isAproveRefund, setIsAproveRefund] = useState(false);
  const [isApproveCelcoin, setIsAproveCelcoin] = useState(false);
  const [showModalCreateDevoluction, setShowModalCreateDevoluction] = useState(false);
  const [openModalReceipt, setOpenModalReceipt] = useState(false);
  const [blobTicket, setBlobTicket] = useState('');
  const [isLoadingTicket, setIsloadingTicket] = useState(false);
  const { handleSubmit: handleToken, control: tokenControl } = useForm({});

  const options = useMemo(() => {
    const baseOptions = {
      options: [
        { label: 'Aprovar', action: 'approve' },
        { label: 'Negar', action: 'deny' },
      ],
      function: (action) => verifyAction(action),
    };

    if (allowRefund) {
      baseOptions.options = [{ label: 'Solicitar reembolso', action: 'refund' }];

      baseOptions.function = () => handleRequestRefund();
      return baseOptions;
    }

    if (refund && showButton) {
      baseOptions.options = [
        { label: 'Aprovar', action: 'approve' },
        { label: 'Negar', action: 'deny' },
      ];
      baseOptions.function = (action) => verifyActionRefund(action);
      return baseOptions;
    }

    if (!refund) {
      baseOptions.options = [{ label: 'Aprovar status', action: 'approveStatus' }, ...baseOptions.options];
      return baseOptions;
    }

    return baseOptions;
  });

  const handleRequestRefund = () => {
    setShowModalCreateDevoluction(true);
  };

  const handleDataForm = (data) => {
    setShowTwoFactorModal(false);
    if (isApproveCelcoin) return aprovedCelcoin(data);

    return isAprove ? aproved(data) : deny(data);
  };

  const handleRefundDataForm = (data) => {
    setShowTwoFactorModal(false);

    if (isAproveRefund) return aprovedRefund(data);
    if (!isAproveRefund) return denyRefund(data);
  };

  const handleOpenModalReceipt = async (idTransaction) => {
    setIsloadingTicket(true);
    try {
      const pdf = await getReceiptForView(idTransaction);
      setBlobTicket(pdf);
      setOpenModalReceipt(true);
    } catch (error) {
      console.error('Erro ao visualizar comprovante', error);
      dispatch(
        showAlert({
          title: 'Erro',
          text: 'Não foi possível carregar o comprovante para visualização.',
          icon: 'error',
        }),
      );
    } finally {
      setIsloadingTicket(false);
    }
  };

  const handleCloseModalReceipt = () => {
    setOpenModalReceipt(false);
  };

  const deny = (data) => {
    dispatch(
      pixTransactionNegadedFetchAction(
        {
          ID_TRANSACAO: idTransaction,
          TOKEN: data,
        },
        onClose,
      ),
    );
  };

  const aproved = (data) => {
    setDisableButon(true);
    dispatch(
      pixTransactionAproveFetchAction(
        {
          ID_TRANSACAO: [idTransaction],
          TOKEN: data,
        },
        onClose,
      ),
    );
  };

  const aprovedCelcoin = (data) => {
    setDisableButon(true);
    dispatch(
      pixTransactionAproveCelcoinFetchAction(
        {
          ID_TRANSACAO: idTransaction,
          TOKEN: data,
        },
        onClose,
      ),
    );
  };

  const denyRefund = (data) => {
    dispatch(
      pixRefundNegadedFetchAction(
        {
          ID_TRANSACAO: idTransaction,
          TOKEN: data,
        },
        onClose,
      ),
    );
  };

  const aprovedRefund = (data) => {
    setDisableButon(true);
    dispatch(
      pixRefundAproveFetchAction(
        {
          ID_TRANSACAO: idTransaction,
          TOKEN: data,
        },
        onClose,
      ),
    );
  };

  const verifyAction = (action) => {
    switch (action) {
      case 'approve':
        setShowTwoFactorModal(true);
        setIsAprove(true);
        break;
      case 'deny':
        setShowTwoFactorModal(true);
        setIsAprove(false);
        break;
      case 'approveStatus':
        setShowTwoFactorModal(true);
        setIsAproveCelcoin(true);
        break;
      default:
        dispatch(
          showAlert({
            title: 'Ops...',
            text: 'Não foi possivel concluir a ação',
            icon: 'error',
            func: onClose,
          }),
        );
        break;
    }
  };

  const verifyActionRefund = (action) => {
    console.log('action', action);
    if (action === 'approve') {
      setShowTwoFactorModal(true);
      setIsAproveRefund(true);
      return;
    } else if (action === 'deny') {
      setShowTwoFactorModal(true);
      setIsAproveRefund(false);
      return;
    }
  };

  return (
    <Styled.ContainerStyled>
      <Styled.TitleStyled>{title}</Styled.TitleStyled>
      {typeof data === 'string' ? (
        <Styled.ParagraphName>{data}</Styled.ParagraphName>
      ) : (
        <>
          {data?.map((data, index) => {
            return (
              <Styled.RowContainer key={index} role={'information-row'}>
                <Styled.ParagraphName>{data.name}</Styled.ParagraphName>
                <Styled.ParagraphValue color={color} bold={bold}>
                  {data.value}
                </Styled.ParagraphValue>
              </Styled.RowContainer>
            );
          })}
          {(showButton || isAproved) && (
            <Grid sx={{ display: 'flex', flexWrap: 'nowrap', justifyContent: 'space-between' }}>
              <Button
                backgroundcolor={theme.colors.buttonSearch}
                width={'16vw'}
                hoverbgcolor={theme.colors.buttonSearchHover}
                hovercolor={theme.colors.buttonSearchHoverText}
                mycolor={theme.colors.buttonSearchText}
                onClick={() => handleOpenModalReceipt(idTransaction)}
              >
                {isLoadingTicket ? 'Carregando...' : 'Comprovante'}
              </Button>
              <Styled.EditButtonContainer flexWrap={'nowrap'}>
                <DropDown
                  openModalPassword={() => setExpanded(true)}
                  name="Ações"
                  options={options?.options}
                  setNameSelectedItem={(action) => options?.function(action)}
                />
              </Styled.EditButtonContainer>
            </Grid>
          )}
        </>
      )}
      {showTwoFactorModal && !refund && (
        <ModalTwoFactor
          open={showTwoFactorModal}
          onClose={() => setShowTwoFactorModal(false)}
          handleToken={handleToken}
          onSubmit={(data) => handleDataForm(data)}
          control={tokenControl}
        />
      )}
      {showTwoFactorModal && refund && (
        <ModalTwoFactor
          open={showTwoFactorModal}
          onClose={() => setShowTwoFactorModal(false)}
          handleToken={handleToken}
          onSubmit={(data) => handleRefundDataForm(data)}
          control={tokenControl}
        />
      )}

      {showModalCreateDevoluction && (
        <ModalPixRefundCreateDevoluction
          open={showModalCreateDevoluction}
          handleClose={() => setShowModalCreateDevoluction(false)}
          idTransaction={idTransaction}
        />
      )}
      {openModalReceipt && (
        <ViewPdfIframe
          open={openModalReceipt}
          handleClose={handleCloseModalReceipt}
          file={blobTicket}
          title="Comprovante"
          isLoading={isLoadingTicket}
        />
      )}
    </Styled.ContainerStyled>
  );
}

InformationPix.propTypes = {
  title: PropTypes.string,
  data: PropTypes.array,
  color: PropTypes.string,
  bold: PropTypes.bool,
  children: PropTypes.node,
  idTransaction: PropTypes.string,
};
